/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-11 10:48:19
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-03-11 14:00:00
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/Components/RightConfigWrapper/index.tsx
 */
import React from 'react';
import css from './css.less';

const RightConfigWrapper = (props) => {
  const { elements = [], title, subtitle, wrapperClassName } = props;
  return (
    <div className={`${css.wrapper} ${wrapperClassName}`}>
      <div className={css.title}>{title}</div>
      {subtitle && <div className={css.subtitle}>{subtitle}</div>}
      <div className={css.elementsContainer}>
        {elements.map((i, index, self) => {
          const { key, body } = i;
          return (
            <React.Fragment key={key}>
              <div className={css.elementContainer}>{body}</div>
              {self.length - 1 !== index && (
                <div className={css.splitLineContainer}>
                  <div className={css.splitLine} />
                </div>
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default RightConfigWrapper;
